import { ApiInstance } from '../instance';

export type AdPayload = {
  adset_id: string;
  name: string;
  questions: Record<string, any>[];
};

export const AdController = {
  getAds: async (payload: { adset_id: string }) => {
    return await ApiInstance.post(`/advertisers/ads`, payload);
  },
  getAd: async (payload: { id: string }) => {
    return await ApiInstance.get(`/advertisers/ads/${payload.id}`);
  },
  createAd: async (payload: AdPayload) => {
    return await ApiInstance.post(`/advertisers/ads/create`, payload);
  },
};
